module.exports = __webpack_public_path__ + "static/media/logo-small.52e69859.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/irontrade/logo-small.png
// module id = 1235
// module chunks = 103